
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 24 24"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M7.5 12.75c-2.688 0-4.875-2.187-4.875-4.875S4.812 3 7.5 3s4.875 2.187 4.875 4.875S10.188 12.75 7.5 12.75zm0-8.25c-1.861 0-3.375 1.514-3.375 3.375S5.639 11.25 7.5 11.25s3.375-1.514 3.375-3.375S9.361 4.5 7.5 4.5zM14.25 21a.75.75 0 01-.75-.75c0-3.308-2.692-6-6-6s-6 2.692-6 6a.75.75 0 01-1.5 0c0-4.135 3.365-7.5 7.5-7.5s7.5 3.365 7.5 7.5a.75.75 0 01-.75.75zM17.727 14.25a4.13 4.13 0 01-4.125-4.125C13.602 7.85 15.453 6 17.727 6s4.125 1.85 4.125 4.125a4.13 4.13 0 01-4.125 4.125zm0-6.75c-1.448 0-2.625 1.178-2.625 2.625s1.177 2.625 2.625 2.625 2.625-1.178 2.625-2.625S19.175 7.5 17.727 7.5z"}}),_c('path',{attrs:{"d":"M23.25 21a.75.75 0 01-.75-.75 4.73 4.73 0 00-.295-1.648 4.742 4.742 0 00-2.481-2.685 4.736 4.736 0 00-3.653-.145.754.754 0 01-.963-.444.745.745 0 01.444-.963 6.246 6.246 0 012.165-.388 6.302 6.302 0 015.894 4.106c.258.696.389 1.425.389 2.167a.75.75 0 01-.75.75z"}})])
          )
        }
      }
    